<template>
  <div>
    <b-jumbotron lead="Contrats à vérifier"/>
    <b-container>
      <b-row>
        <b-col class="text-lg-left">
          <b-button @click="initMonths(previousMonth)">&lsaquo; {{ previousMonth.format('MMMM YYYY') }}</b-button>
        </b-col>
        <b-col>
          {{ currentMonth.format('MMMM YYYY') }}
        </b-col>
        <b-col class="text-lg-right">
          <b-button @click="initMonths(nextMonth)">{{ nextMonth.format('MMMM YYYY') }}  &rsaquo;</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="contracts.length === 0">Pas de vérification à effectuer</b-container>
    <b-container v-else>
      <b-row>
        <b-col>
          <b-form-group
            label="Filtrer"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Taper pour rechercher un id ou une référence de facturation"/>
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''">Effacer</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        :fields="fields"
        :items="contracts"
        :filter="filter"
        :filter-included-fields="filterOn"
        small
        @filtered="onFiltered">
        <template #cell(cont_id)="data"
          class="align-middle">
          {{ data.value }}
        </template>
        <template #cell(establishments)="data">
          <div v-if="data.value.length === 0"><i>Pas d'établissement lié</i></div>
          <div
            v-for="establishment in data.value"
            v-else
            :key="establishment.esta_name">{{ establishment.esta_name }}</div>
            <!--TODO : Ajouter un petit bouton pour visualiser l'etablissement -->
        </template>
        <template #cell(bils_reference)="data">
          <div>{{ data.value }}</div>
        </template>
        <template #cell(billing_check)="row">
          <b-row>
            <div class="anisen-center">
              <div
                :class="{success: row.item.bils_is_done,
                         danger: !row.item.bils_is_done,
                         pending: row.item.bils_is_done && !row.item.bils_is_paid}"
                class="pill" />
              <div v-if="!row.item.bils_is_done"> À facturer ({{ row.item.bils_amount }} €)</div>
              <div v-else-if="row.item.bils_is_done && !row.item.bils_is_paid">En attente de paiement</div>
              <div v-else>Facturé et payé</div>
            </div>
          </b-row>
        </template>

        <template #cell(action)="row">
          <div v-if="!row.item.bils_is_done"><b-button
            variant="primary"
            @click="billed(row.item.bils_id)">Facturé</b-button></div>
          <div v-else-if="row.item.bils_is_done && !row.item.bils_is_paid"><b-button
            variant="primary"
            @click="paid(row.item.bils_id, row.item.bils_amount)">Payé</b-button></div>
          <div v-else><i>Pas d'action possible</i></div>
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
import { mapState } from 'vuex';

const moment = require('moment');

moment().format();

export default {
  data() {
    return {
      fields: [
        {
          cont_id: {
            label: 'Numéro de contrat',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          establishments: {
            label: 'Établissements',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          bils_reference: {
            label: 'Référence Facturation',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          billing_check: {
            label: 'Facturation',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          action: {
            label: 'Action',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      currentMonth: null,
      previousMonth: null,
      nextMonth: null,
    };
  },
  computed: mapState({
    contracts: state => state.billing_schedule.schedulesByMonth,
  }),
  beforeMount() {
    this.initMonths();
  },
  mounted() {
    // this.initMonths();
  },
  created() {
    this.initContracts();
  },
  methods: {
    onFiltered(filteredItems) {
      console.log('Filtered', filteredItems);
    },
    paid(id, billAmount) {
      console.log('paid');
      this.$store.dispatch('billing_schedule/billPaid', [id, billAmount])
        .then(() => this.initContracts())
        .catch(error => (console.log(error)));
    },
    billed(id) {
      console.log(`billed ${id}`);
      this.$store.dispatch('billing_schedule/billSent', id)
        .then(() => this.initContracts())
        .catch(error => (console.log(error)));
    },
    initMonths(monthDate) {
      if (!monthDate) {
        // eslint-disable-next-line no-param-reassign
        monthDate = moment();
      } else {
        // eslint-disable-next-line no-param-reassign
        monthDate = moment(monthDate);
      }
      this.currentMonth = monthDate;
      this.previousMonth = moment(monthDate).subtract(1, 'M');
      this.nextMonth = moment(monthDate).add(1, 'M');
      this.initContracts();
    },
    initContracts() {
      this.$store.dispatch('billing_schedule/getBillingScheduleForMonth', this.currentMonth.format('MM-YYYY'));
    },
  },
};
</script>
<style type="text/css">
  .container {
    padding: 10px;
  }
  .pill {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin: 5px;
  }
  .success {
    background-color: green;
  }
  .danger {
    background-color: red;
  }
  .pending {
    background-color: orangered;
  }
  .anisen-center {
    display: inline-flex;
    width: fit-content;
    margin: auto;
  }
</style>
